var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{key:_vm.logoKey,class:{ 'site-logo--default-header': _vm.isDefaultHeader },attrs:{"src":_vm.source},on:{"error":_vm.useDefault}})}
var staticRenderFns = []

export { render, staticRenderFns }